var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscriptionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9240_992)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#27272C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4209 53.0785V60.9888C63.4209 62.2226 61.9166 62.8404 61.0374 61.9671L58.4032 59.356C54.519 62.9297 49.3936 65 43.9998 65C33.5231 65.0018 24.5082 57.2612 23.0269 46.997C22.8203 45.5619 23.8267 44.2319 25.2744 44.0271C26.708 43.8206 28.0622 44.8199 28.2706 46.255C29.3793 53.9483 36.1414 59.7515 43.9981 59.7515C47.9776 59.7515 51.7665 58.2535 54.6637 55.6529L52.3544 53.3638C51.4752 52.4922 52.0984 51.0012 53.3413 51.0012H61.3216C62.4798 51.0012 63.4173 51.9305 63.4173 53.0785H63.4209ZM64.9728 41.0047C63.4915 30.7406 54.4766 23 43.9998 23C38.6061 23 33.4807 25.0703 29.5965 28.644L26.9641 26.0346C26.0848 25.1631 24.5806 25.7809 24.5806 27.0129V34.9232C24.5806 36.0713 25.5181 37.0006 26.6763 37.0006H34.6548C35.8995 37.0006 36.5227 35.5095 35.6417 34.638L33.3342 32.3489C36.2296 29.7483 40.0203 28.2502 43.9998 28.2502C51.8565 28.2502 58.6186 34.0517 59.7273 41.7468C59.9162 43.0558 61.0497 44.0009 62.3456 44.0009C62.4692 44.0009 62.5981 43.9921 62.7235 43.9746C64.1712 43.7699 65.1811 42.4398 64.9728 41.0047Z",
    fill: "#D6D6D7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9240_992"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionIcon);
export default __webpack_public_path__ + "static/media/subscription-icon.bdfbdce25044084a78d69fb732a272b1.svg";
export { ForwardRef as ReactComponent };